module.exports = __webpack_public_path__ + "static/media/rak-properties.36f6704f.png";